import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { cartCartSelector } from '../../../redux/selectors/cartSelector'
import useCurrencyConverter from '../../../hooks/useCurrencyConverter'
import CustomCartFilters from '../../../components/Filter/CustomCartFilters'
import './customBills.scss'
import Cards from '../../../components/Cards'
import { setAccountFormIsVisible } from '../../../redux/actions/pagesActions'

function CustomBill ({
    currentBill,
    cart,
    pageLoading,
    setFormIsVisible,
    lang,
}) {
    const cost = useMemo(() => currentBill?.cost ?? 0, [currentBill?.cost])

    const priceConverted = useCurrencyConverter(currentBill?.cost, cart?.currency?.rate)
    const totalConverted = useCurrencyConverter(cost, cart?.currency?.rate)
    const sign = <span dangerouslySetInnerHTML={{ __html: cart?.currency?.sign }}></span>

    return (
        <>
            <section
                className={`section--table custom_bills section--table--${cart?.currency?.currency?.toLowerCase()}`}
            >
                <CustomCartFilters showCurrency={true} showBills={true}/>

                <div className={'section__row section__header'}>
                    <div className={'section__cell section__cell--name'}>
                        {/* <span>{customBills?.translate?.boxTitle}</span>*/}
                    </div>
                    <div className={'section__cell section__cell--sum hide-tablet'}>
                        <span>Sum</span>
                    </div>
                </div>

                <div className={'section__row section__row--main'}>
                    <div className={'section__cell section__cell--name'}>
                        <div>
                            <div className={'title-3 section__title--spaced'}>
                                {/*<LoadingContent />*/}
                                {!pageLoading && (
                                    <>
                                        {currentBill?.title}
                                    </>
                                )}
                            </div>
                            <div className={'section--mobile-space-compensate'}>
                                <span className="accordion__summary"></span>
                                {!pageLoading && (
                                    <ul className={'list list--2-col'}>
                                        <li key={'product-description'}>{lang?.notPaid}</li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={'section__cell section__cell--sum tablet-pt-7'}>
                        <span className={'text-3 bold hide-desktop'}>Sum</span>
                        {sign}&nbsp;
                        {!pageLoading && (
                            <>
                                {priceConverted}
                            </>
                        )}
                    </div>
                </div>
                <>
                    <div className={'section__row section__row--border-top'}>
                        <div className={'section__cell section__cell--name'}>

                        </div>
                        <div className={'section__cell section__cell--total'}>
                            <div className={'flex flex--space-between mt-10'}>
                                <span className={'text-3'}>Total price</span>
                                <span className={`text-3`}>
                              {sign} {!pageLoading && (
                                    <>
                                        {totalConverted}
                                    </>
                                )}
                        </span>
                            </div>
                        </div>
                    </div>
                </>
            </section>

            <Cards setAccountFormIsVisible={setFormIsVisible}/>
        </>
    )
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
})

const mapDispatchToProps = (dispatch) => ({
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomBill)
